import { render } from "./WeekSlider.vue?vue&type=template&id=07fd2144&scoped=true"
import script from "./WeekSlider.vue?vue&type=script&lang=js"
export * from "./WeekSlider.vue?vue&type=script&lang=js"

import "./WeekSlider.vue?vue&type=style&index=0&id=07fd2144&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fd2144"]])

export default __exports__